import { ENUM__error_type } from '../asserts/ENUM__error_type';
import { ERROR__with_assert_data } from '../asserts/ERROR__with_assert_data';
import { DTO_RESPONSE__error } from '../network/DTO_RESPONSE__error';

export function error_to_response_error(error: unknown): DTO_RESPONSE__error {
  let out;

  if (error instanceof DTO_RESPONSE__error) {
    out = error.clone();
  } else if (error instanceof ERROR__with_assert_data) {
    out = new DTO_RESPONSE__error(error.assert_type, error.assert_payload);
  } else {
    out = new DTO_RESPONSE__error(ENUM__error_type.UNKNOWN, { message: error_to_string(error) });
  }

  return out;
}

export function error_to_string(target: unknown): string {
  let out = 'Unknown error';

  if (target instanceof DTO_RESPONSE__error) {
    out = target.type;
  } else if (target instanceof Error) {
    out = target.message;
  } else if (typeof target === 'string') {
    out = target;
  } else if (target && typeof target === 'object' && 'error' in target) {
    out = String(JSON.stringify(target.error));
  } else if (target && typeof target === 'object' && 'message' in target) {
    out = String(JSON.stringify(target.message));
  }

  if (out == 'Unknown error') debugger;

  return out;
}
